import {Button, ConfigProvider, Dropdown, MenuProps, notification, Row, Space, Tooltip, Upload, Modal, message} from 'antd';
import React, {Component} from 'react';
import './index.css';
import enUSIntl from "antd/lib/locale/en_US";
import ProTable, {ProColumns} from "@ant-design/pro-table";
import {postRequest} from "../../../api/postRequest";
import {CloudDownloadOutlined, CloudUploadOutlined, DownloadOutlined, DownOutlined, FileTextOutlined, TeamOutlined, UploadOutlined} from "@ant-design/icons";
import {humanFileSize} from "../../../common/utils";
import {auth} from "../../../config/firebase";
import axios from "axios";
import {API} from "../../../common/constants";
import withRouter from "../../../components/withRouter";
import type { UploadFile } from 'antd/es/upload/interface';


export interface IPaymentCycleCustomerReportsProps {
    //Here we pass the Props Interface
    params: any
    pageSize?: number
    polling?: false | number
}

export interface IPaymentCycleCustomerReportsState {
    data?: any
    filteredData?: any
    loading: boolean
    topPerformanceModalVisible: boolean
    topPerformanceFileList: UploadFile[]
    uploadingTopPerformance: boolean
    uploadModalVisible: boolean
    uploadFileList: UploadFile[]
    uploadingToVault: boolean
}


type PaymentCycleCustomerReport = {
    file_name: string;
    product: string;
    path: string;
    customer_id: number;
    size: number;
};


//class ComponentName Component<PropsInterface, StateInterface>
class PaymentCycleCustomerReports extends Component<IPaymentCycleCustomerReportsProps, IPaymentCycleCustomerReportsState> {

    constructor(props: IPaymentCycleCustomerReportsProps) {
        super(props);

        this.state = {
            loading: false,
            topPerformanceModalVisible: false,
            topPerformanceFileList: [],
            uploadingTopPerformance: false,
            uploadModalVisible: false,
            uploadFileList: [],
            uploadingToVault: false,
        }
    }

    //Add style here
    style = {};


    // Before the component mounts, we initialise our state
    componentWillMount() {

    }

    // After the component did mount, we set the state.
    componentDidMount() {
        this.getData()
    }

    getData = async () => {
        this.setState({loading: true})
        try {
            const res = await postRequest('/api/paymentCycles/getCustomerReports/' + this.props.params.id)
            // console.log(res.data)
            this.setState({data: res.data, loading: false})
        } catch (e) {
            // return
            this.setState({loading: false})
        }
    }

    columns: ProColumns<PaymentCycleCustomerReport>[] = [
        {
            title: 'Filename', dataIndex: 'file_name', valueType: 'text',
        },
        {
            title: 'Customer Id', dataIndex: 'customer_id', valueType: 'text',
        },
        {
            title: 'Product', dataIndex: 'product',
            valueType: 'select',
            valueEnum: {
                'Youtube Entertainment': {text: 'Youtube Entertainment'},
                'Youtube Music': {text: 'Youtube Music'},
                'Spotify': {text: 'Spotify'},
                'MD': {text: 'Music Distribution'}
            },
        },
        {
            title: 'Size',
            dataIndex: 'size',
            render: (num) => humanFileSize(num as number),
            sorter: (a, b) => a.size - b.size, defaultSortOrder: "descend",
            hideInSearch: true
        },
        {
            title: 'Action',
            align: "center",
            hideInSearch: true,
            render: (dom, entity) =>
                (
                    <Tooltip title={"Download customer report"}>
                        <Button icon={<DownloadOutlined/>} type={"text"} shape={"circle"} onClick={
                            () => this.downloadSingleReport(entity)
                        }/>
                    </Tooltip>
                ),
        },
    ];

    downloadSingleReport = async (entity: PaymentCycleCustomerReport) => {
        // console.log(filepath)
        const token = await auth.currentUser?.getIdToken()
        axios
            .post(API + '/api/paymentCycles/downloadCustomerReport/' + this.props.params.id, null,
                {
                    headers: {
                        "Accept": "*/*",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob',
                    params: {filepath: entity.path}
                })
            .then(res => {
                // console.log(res)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', entity.file_name + '.xlsx');
                document.body.appendChild(link);
                link.click();

                // notification.success({message: 'Success'})
            }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    onSearch = (params: PaymentCycleCustomerReport) => {
        let filteredData: PaymentCycleCustomerReport[] = JSON.parse(JSON.stringify(this.state.data))
        Object.keys(params).map((key) => {
            if (params[key] == '') return true
            filteredData = filteredData.filter((datum) => {
                // console.log(key, params[key], datum[key].toString().toLowerCase().includes(params[key].toLowerCase()))
                // return datum[key] == params[key] // strict comparison
                return datum[key].toString().toLowerCase().includes(params[key].toLowerCase()) // loose comparison
            })
        })
        this.setState({filteredData})
    }
    onReset = () => {
        this.onSearch({} as any)
    }

    generateYoutubeEntertainmentReports = () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        postRequest('/api/paymentCycles/generateYoutubeEntertainmentReports/' + this.props.params.id).then(value => {
            // console.log(value)
            notification.success({message: 'Done'})
        }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    generateYoutubeMusicReports = () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        postRequest('/api/paymentCycles/generateYoutubeMusicReports/' + this.props.params.id).then(value => {
            // console.log(value)
            notification.success({message: 'Done'})
        }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    generateSpotifyReports = () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        postRequest('/api/paymentCycles/generateSpotifyReports/' + this.props.params.id).then(value => {
            // console.log(value)
            notification.success({message: 'Done'})
        }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    generateMusicDistributionReports = () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        postRequest('/api/paymentCycles/generateMusicDistributionReports/' + this.props.params.id).then(value => {
            // console.log(value)
            notification.success({message: 'Done'})
        }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    uploadCustomerReportsToDrive = () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        postRequest('/api/paymentCycles/uploadCustomerReportsToDrive/' + this.props.params.id).then(() => {
            notification.success({message: 'Upload started successfully'})
        }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    downloadCustomerReportsAll = async () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        const token = await auth.currentUser?.getIdToken()
        axios
            .post(API + '/api/paymentCycles/downloadCustomerReportsAll/' + this.props.params.id, null,
                {
                    headers: {
                        "Accept": "*/*",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                })
            .then(res => {
                console.log(res)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'customer_reports_' + this.props.params.id + '.zip');
                document.body.appendChild(link);
                link.click();

                notification.success({message: 'Success'})
            }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    downloadCustomerReportsAllByCustomerId = async () => {
        notification.info({message: 'Operation started. Please check the logs for status updates.'})
        const token = await auth.currentUser?.getIdToken()
        axios
            .post(API + '/api/paymentCycles/downloadCustomerReportsAllByCustomerId/' + this.props.params.id, null,
                {
                    headers: {
                        "Accept": "*/*",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                })
            .then(res => {
                console.log(res)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'customer_reports_by_customer_id_' + this.props.params.id + '.zip');
                document.body.appendChild(link);
                link.click();

                notification.success({message: 'Success'})
            }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    generateArcadiumSummaryReport = async () => {
        notification.info({message: 'Generating Arcadium Summary Report. Please wait...'})
        const token = await auth.currentUser?.getIdToken()
        axios
            .post(API + '/api/paymentCycles/generateArcadiumSummaryReport/' + this.props.params.id, null,
                {
                    headers: {
                        "Accept": "*/*",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                })
            .then(res => {
                console.log(res)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Arcadium_Summary_Report_' + this.props.params.id + '.xlsx');
                document.body.appendChild(link);
                link.click();

                notification.success({message: 'Report downloaded successfully'})
            }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error generating report'})
        })
    }

    showTopPerformanceModal = () => {
        this.setState({topPerformanceModalVisible: true, topPerformanceFileList: []})
    }

    handleTopPerformanceCancel = () => {
        this.setState({topPerformanceModalVisible: false, topPerformanceFileList: []})
    }

    handleTopPerformanceUpload = async () => {
        const {topPerformanceFileList} = this.state

        if (topPerformanceFileList.length !== 2) {
            message.error('Please upload exactly 2 files')
            return
        }

        // Validate file names
        const fileNames = topPerformanceFileList.map(f => f.name.toUpperCase())
        const hasEdit = fileNames.some(name => name.includes('EDIT'))
        const hasSpotify = fileNames.some(name => name.includes('SPOTIFY'))

        if (!hasEdit || !hasSpotify) {
            message.error('One file must contain "EDIT" and one must contain "SPOTIFY" in the name')
            return
        }

        this.setState({uploadingTopPerformance: true})

        const formData = new FormData()
        topPerformanceFileList.forEach(file => {
            if (file.originFileObj) {
                formData.append('files', file.originFileObj)
            }
        })

        try {
            const token = await auth.currentUser?.getIdToken()
            const response = await axios.post(
                API + '/api/paymentCycles/generateArcadiumTopPerformanceReport/' + this.props.params.id,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                    responseType: 'blob'
                }
            )

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Arcadium - Top Performance Music Tracks ' + this.props.params.id + '.xlsx')
            document.body.appendChild(link)
            link.click()

            notification.success({message: 'Top Performance Report downloaded successfully'})
            this.setState({topPerformanceModalVisible: false, topPerformanceFileList: [], uploadingTopPerformance: false})
        } catch (error) {
            console.error(error)
            notification.error({message: 'Error generating Top Performance Report'})
            this.setState({uploadingTopPerformance: false})
        }
    }

    showUploadModal = () => {
        this.setState({uploadModalVisible: true, uploadFileList: []})
    }

    handleUploadCancel = () => {
        this.setState({uploadModalVisible: false, uploadFileList: []})
    }

    handleUploadToVault = async () => {
        const {uploadFileList} = this.state

        if (uploadFileList.length !== 1) {
            message.error('Please upload exactly 1 file')
            return
        }

        this.setState({uploadingToVault: true})

        const formData = new FormData()
        if (uploadFileList[0].originFileObj) {
            formData.append('file', uploadFileList[0].originFileObj)
        }

        try {
            const token = await auth.currentUser?.getIdToken()
            const response = await axios.post(
                API + '/api/paymentCycles/uploadArcadiumTopPerformanceReportToVault/' + this.props.params.id,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )

            notification.success({message: 'Report uploaded to vault successfully'})
            this.setState({uploadModalVisible: false, uploadFileList: [], uploadingToVault: false})
        } catch (error) {
            console.error(error)
            notification.error({message: 'Error uploading report to vault'})
            this.setState({uploadingToVault: false})
        }
    }

    render() {


        return (
            <>

                {/*<Typography.Title level={4}>Payment Cycle {this.props.cycle_id} Logs</Typography.Title>*/}

                <Row justify={"space-between"}>

                    <Space>

                        <Button onClick={this.generateYoutubeEntertainmentReports}>Generate Youtube Entertainment
                            Reports</Button>
                        <Button onClick={this.generateYoutubeMusicReports}>Generate Youtube Music Reports</Button>
                        <Button onClick={this.generateSpotifyReports}>Generate Spotify Reports</Button>
                        <Button onClick={this.generateMusicDistributionReports}>Generate Music Distribution
                            Reports</Button>

                        <Dropdown menu={{
                            items: [
                                {
                                    key: 'summary',
                                    label: 'Summary Report',
                                    onClick: this.generateArcadiumSummaryReport
                                },
                                {
                                    key: 'performance',
                                    label: 'Top Performance Report',
                                    onClick: this.showTopPerformanceModal
                                },
                                {
                                    key: 'upload-performance',
                                    label: 'Upload Top Performance to Vault',
                                    onClick: this.showUploadModal
                                }
                            ]
                        }}>
                            <Button>
                                Arcadium <DownOutlined />
                            </Button>
                        </Dropdown>

                    </Space>

                    <Space>
                        <Button icon={<CloudUploadOutlined/>} onClick={this.uploadCustomerReportsToDrive}>Upload Excels
                            to Drive</Button>
                        <Button icon={<CloudDownloadOutlined/>} onClick={this.downloadCustomerReportsAll}>Download All
                            Reports</Button>
                        <Button icon={<TeamOutlined/>} onClick={this.downloadCustomerReportsAllByCustomerId}>Download
                            All
                            Reports By Customer</Button>
                    </Space>


                </Row>

                <br/>

                <ConfigProvider locale={enUSIntl}>

                    {/*<Card bodyStyle={{padding: 0}}>*/}

                    <ProTable<PaymentCycleCustomerReport>
                        columns={this.columns}
                        // actionRef={this.state.actionRef as any}
                        // cardBordered
                        bordered
                        loading={this.state.loading}
                        // size={"small"}
                        // style={{fontSize:6}}
                        // showHeader={false}
                        // headerTitle={"Logs"}
                        polling={this.props.polling || 0}
                        // request={async (params = {}, sort, filter) => {
                        //     // console.log('REQUEST', params, filter)
                        //     const res = await postRequest('/api/paymentCycles/getCustomerReports/' + this.props.cycle_id)
                        //     const data = res.data || []
                        //     this.setState({data: res.data, filteredData: null})
                        //     return {data, success: true, total: data.length}
                        // }}
                        rowKey={(record) => record.file_name}
                        locale={{emptyText: <Space direction={'vertical'}> <FileTextOutlined/> No files</Space>}}
                        pagination={{pageSize: this.props.pageSize || 10, hideOnSinglePage: true}}
                        dateFormatter="string"
                        // search={false}
                        onSubmit={this.onSearch}
                        onReset={this.onReset}
                        search={{layout: "vertical"}}
                        dataSource={this.state.filteredData ? this.state.filteredData : this.state.data}
                        toolBarRender={false}
                        // toolbar={{style: {marginBottom: 20, textAlign: "end"}}}
                        // toolBarRender={() => []}
                    />
                    {/*</Card>*/}


                </ConfigProvider>

                <Modal
                    title="Generate Arcadium Top Performance Report"
                    open={this.state.topPerformanceModalVisible}
                    onOk={this.handleTopPerformanceUpload}
                    onCancel={this.handleTopPerformanceCancel}
                    confirmLoading={this.state.uploadingTopPerformance}
                    okText="Generate Report"
                    width={600}
                >
                    <p>Please upload 2 Excel files:</p>
                    <ul>
                        <li>One file containing "EDIT" in the name (Music Distribution report)</li>
                        <li>One file containing "SPOTIFY" in the name (Spotify report)</li>
                    </ul>
                    <Upload
                        fileList={this.state.topPerformanceFileList}
                        onChange={({fileList}) => this.setState({topPerformanceFileList: fileList})}
                        beforeUpload={(file) => {
                            // Prevent auto upload
                            const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls')
                            if (!isExcel) {
                                message.error('You can only upload Excel files!')
                                return Upload.LIST_IGNORE
                            }
                            return false
                        }}
                        multiple
                        accept=".xlsx,.xls"
                        maxCount={2}
                    >
                        <Button icon={<UploadOutlined />}>Select Files</Button>
                    </Upload>
                </Modal>

                <Modal
                    title="Upload Arcadium Top Performance Report to Vault"
                    open={this.state.uploadModalVisible}
                    onOk={this.handleUploadToVault}
                    onCancel={this.handleUploadCancel}
                    confirmLoading={this.state.uploadingToVault}
                    okText="Upload to Vault"
                    width={600}
                >
                    <p>Please upload the Top Performance Report Excel file:</p>
                    <Upload
                        fileList={this.state.uploadFileList}
                        onChange={({fileList}) => this.setState({uploadFileList: fileList})}
                        beforeUpload={(file) => {
                            // Prevent auto upload
                            const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls')
                            if (!isExcel) {
                                message.error('You can only upload Excel files!')
                                return Upload.LIST_IGNORE
                            }
                            return false
                        }}
                        accept=".xlsx,.xls"
                        maxCount={1}
                    >
                        <Button icon={<UploadOutlined />}>Select File</Button>
                    </Upload>
                </Modal>

            </>
        );
    }
}

export default withRouter(PaymentCycleCustomerReports);